import React, { Component } from 'react';
import Promise from 'bluebird';

// Components
import { ResponsiveImage } from 'dabbl-react-components';
import {
  Container,
  Row,
  Col
} from 'reactstrap';

// Images
import facebookIcon from '../../../../assets/images/facebook-icon.png';
import twitterIcon from '../../../../assets/images/twitter-icon.png';
import {RETAILER_TWITTER_URL, META_OG_URL, EMPTY_SCREEN_IMAGE} from "../../../../retailerValues";
import {logAmplitudeSocialShare} from "../../../../amplitude";

class FinishedAllCampaignsMessage extends Component {

  componentDidMount() {
    // Send Mixpanel Event
    // this.props.finishAllCampaignsEvent();
  }

  handleSocialMediaBtnClick(socialMediaName) {
    // Send Mixpanel Event
    // this.props.shareSocialMediaEvent(socialMediaName);
    logAmplitudeSocialShare(socialMediaName)
  }

  render() {
    return (
      <div>
        <Container>
          <Row>
            <Col xs={12} className="text-center">
              <div className="FinishedAllCampaignsMessage_title">
                Great job! You've completed all available experiences!
              </div>
              <div className="FinishedAllCampaignsMessage_subtitle">
                New experiences come in all the time, so please check back again soon.
              </div>
            </Col>

            <Container className="FinishedAllCampaignsMessage_shareContainer">
              <Row>
                <Col xs={12} md={6} className="FinishedAllCampaignsMessage_shareTextCol text-center">
                  <div className="FinishedAllCampaignsMessage_shareText">
                    Let your favorite brands know you want more Downtime Dollars by telling them on Facebook and Twitter!
                  </div>

                  <div className="FinishedAllCampaignsMessage_imgContainer">
                    <a
                      onClick={() => {
                        Promise.resolve()
                        .then(() => this.handleSocialMediaBtnClick('facebook'))
                        .then(() => window.open(`https://www.facebook.com/sharer.php?u=${META_OG_URL}`, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600'));
                        return false;
                      }}
                    >
                      <ResponsiveImage
                        className="FinishedAllCampaignsMessage_img FinishedAllCampaignsMessage_shareIcon"
                        src={facebookIcon}
                        alt="Facebook icon"
                      />
                    </a>
                    <a
                      onClick={() => {
                        this.handleSocialMediaBtnClick('twitter');
                          window.open(RETAILER_TWITTER_URL, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
                        return false;
                      }}
                    >
                      <ResponsiveImage
                        className="FinishedAllCampaignsMessage_img FinishedAllCampaignsMessage_shareIcon"
                        src={twitterIcon}
                        alt="Twitter icon"
                      />
                    </a>
                  </div>
                </Col>

                <Col xs={12} md={6}>
                  <ResponsiveImage src={EMPTY_SCREEN_IMAGE} alt="Finger touching phone" />
                </Col>
              </Row>
            </Container>

          </Row>
        </Container>
      </div>
    );
  }
}

export default FinishedAllCampaignsMessage;



// WEBPACK FOOTER //
// ./src/pages/Campaigns/components/FinishedAllCampaignsMessage/FinishedAllCampaignsMessage.js